import { render, staticRenderFns } from "./MyLessonStudyTest.vue?vue&type=template&id=6539cb0a&scoped=true&"
import script from "./MyLessonStudyTest.vue?vue&type=script&lang=js&"
export * from "./MyLessonStudyTest.vue?vue&type=script&lang=js&"
import style0 from "./MyLessonStudyTest.vue?vue&type=style&index=0&id=6539cb0a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6539cb0a",
  null
  
)

export default component.exports